"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";

export default function CollegeStats({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";
  const primaryBg = content.colorPalette?.primary || "#1E3A8A";

  const stats = content.stats || [
    { value: "50,000+", label: "Students Graduated" },
    { value: "500+", label: "Industry Partners" },
    { value: "95%", label: "Placement Rate" },
    { value: "200+", label: "Expert Faculty" },
  ];

  return (
    <section
      className={`py-20 px-6 text-white transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily, backgroundColor: primaryBg }}
    >
      <div className="max-w-7xl mx-auto space-y-10">
        <div className="text-center space-y-2">
          <h2 className="text-2xl md:text-4xl font-extrabold">
            <EditableText
              value={content.title || "Our Numbers Speak"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {stats.map((stat: any, idx: number) => (
            <div key={idx} className="space-y-2">
              <p className="text-4xl md:text-5xl font-extrabold text-amber-400">{stat.value}</p>
              <p className="text-sm text-white/80 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
